import { render, staticRenderFns } from "./AdminIdi.html?vue&type=template&id=e0460388&scoped=true&"
import script from "./AdminIdi.vue?vue&type=script&lang=js&"
export * from "./AdminIdi.vue?vue&type=script&lang=js&"
import style0 from "./AdminIdi.scss?vue&type=style&index=0&id=e0460388&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0460388",
  null
  
)

export default component.exports